import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

const theme = {};
// Custom app theme stuff
const appTheme = {
  dark: {
    tilesFont: 'rgb(199, 199, 199)',
  },
  light: {
    tilesFont: 'white',
  },
};
theme.dark = createMuiTheme({
  appTheme: appTheme.dark,
  appBar: {
    color: 'white',
  },
  palette: {
    type: 'dark',
    primary: {
      main: '#6366f1',
    },
    background: {
      default: '#1a1a1e',
      paper: '#242428',
    },
    recentlySeen: {
      backgroundColor: '#716e61',
    },
  },
  overrides: {
    MuiInputAdornment: {
      root: {
        color: '#94a3b8',
      },
    },
    MuiOutlinedInput: {
      root: {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(255,255,255,0.15)',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(255,255,255,0.3)',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#6366f1',
        },
      },
    },
    MuiInputLabel: {
      root: {
        color: '#94a3b8',
      },
    },
    MuiSelect: {
      icon: {
        color: '#94a3b8',
      },
    },
    MuiAutocomplete: {
      paper: {
        backgroundColor: '#2a2a2e',
        border: '1px solid rgba(255,255,255,0.15)',
        marginTop: '2px',
      },
      option: {
        '&[data-focus="true"]': {
          backgroundColor: 'rgba(99, 102, 241, 0.15)',
        },
        '&[aria-selected="true"]': {
          backgroundColor: 'rgba(99, 102, 241, 0.25)',
        },
      },
      noOptions: {
        color: '#94a3b8',
      },
      clearIndicator: {
        color: '#94a3b8',
      },
      popupIndicator: {
        color: '#94a3b8',
      },
    },
  },
});
theme.light = createMuiTheme({
  // direction: "rtl",
  appTheme: appTheme.light,
  appBar: {
    color: 'white',
  },
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
    recentlySeen: {
      backgroundColor: '#fff5de',
    },
  },
});
export default theme;
